import { useDroppable } from "@dnd-kit/core";
import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "./Kanban.module.scss";
import KanbanCard from "./KanbanCard";

const KanbanLane = (props) => {
  const {
    title,
    CardClassName = '',
    items,
    heightDelta,
    handleAction,
    isCollapsed,
    onToggleCollapse,
    totalCount,
    onScroll,
    isLoadingMore,
  } = props;
  const { setNodeRef } = useDroppable({
    id: title,
  });

  const getStatusPill = (status) => {
    switch (status) {
      case "In Progress":
        return "pill OnTrack";
      case "Monitoring":
        return "pill OffTrack";
      case "Slipping":
        return "pill AtRisk";
      case "Completed":
        return "pill Completed";
      case "On Hold":
        return "pill OnHold";
      default:
        return "";
    }
  };

  const handleToggleCollapse = (e) => {
    e.stopPropagation();
    onToggleCollapse(title);
  };

  if (isCollapsed) {
    return (
      <div className={`${styles.laneCollapsed} ${getStatusPill(title)}`}>
        <div className={styles.laneCollapsedHeader} onClick={handleToggleCollapse}>
          <ChevronRight size={16} className={styles.collapseIconVertical} />
          <span className={styles.laneCollapsedTitle}>{title}</span>
          <span className={styles.laneCollapsedCount}>{totalCount != null ? totalCount : items.length}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={setNodeRef}
      className={`${styles.kanbanWrapper}`}
      style={{ minHeight: `calc(100vh - ${heightDelta})` }}
      onScroll={onScroll}>
      <div className={styles.laneHeader}>
        <div className={`${styles.laneTitlePill} ${getStatusPill(title)}`}>
          <ChevronLeft
            size={16}
            className={styles.collapseIcon}
            onClick={handleToggleCollapse}
          />
          <span className={styles.laneTitle}>{title}</span>
          <span className={styles.laneCount}>{totalCount != null ? totalCount : items.length}</span>
        </div>
      </div>
      <div className="px-3 py-2">
        {items.map((task, key) => (
          <KanbanCard
            index={key}
            className={CardClassName}
            taskDetails={task}
            handleAction={handleAction}
          />
        ))}
        {isLoadingMore && (
          <div className={styles.laneLoader}>
            <div className={styles.laneLoaderSpinner} />
          </div>
        )}
      </div>
    </div>
  );
};
export default KanbanLane;
